export default __webpack_public_path__ + "static/media/presidentiel.5645f67b.png";